import PropTypes from 'prop-types'

import View from '../../components/bantrab/view'
import Header from '../../components/bantrab/webinars/listing/header'
import Recorded from '../../components/bantrab/webinars/listing/recorded'
import Upcomming from '../../components/bantrab/webinars/listing/upcomming'
import Breadcrumb from '../../components/bantrab/webinars/listing/breadcrumb'
import Suggestions from '../../components/bantrab/webinars/listing/suggestions'
import { getBaseViewInfo } from '../../components/bantrab/view/functions'
import { getPage, getTransmissions as getItems } from '../../api/bantrab'
import { TRANSMISSIONS_LIST_QUERY as ITEMS_LIST_QUERY } from '../../api/bantrab/queries'

const ITEMS_PER_PAGE = parseInt(process.env.NEXT_PUBLIC_BANTRAB_TRANSMISSIONS_PER_PAGE_ON_LISTING)

const INDEX_TYPE = 'transmissions.TransmissionsIndexPage'

async function getServerSideProps () {
  const { head, navbar, footer, raw } = await getBaseViewInfo()

  const indexPages = raw.rootChildrenPages.items.filter(page => page.meta.type === INDEX_TYPE)
  const indexPageId = indexPages[0].id

  let indexPage = await getPage(
    indexPageId,
    {
      fields: '*,suggestions_form(form_fields(*))'
    }
  )
  indexPage = await indexPage.json()

  const states = [
    'upcomming_or_running',
    'closed'
  ]

  const order = {
    upcomming_or_running: {
      order: '-begin_time'
    },
    closed: {
      order: 'begin_time'
    }
  }

  let webinars = await Promise.all(
    states.map(
      transmissionState => getItems({
        ...ITEMS_LIST_QUERY,
        limit: ITEMS_PER_PAGE,
        transmission_state: transmissionState,
        ...order[transmissionState]
      })
    )
  )

  webinars = await Promise.all(
    webinars.map(
      item => item.json()
    )
  )

  webinars = webinars.map(
    (item, index) => [states[index], item]
  )

  webinars = Object.fromEntries(webinars)

  let nearestTransmission = null
  if (webinars.upcomming_or_running.length > 0) {
    nearestTransmission = webinars.upcomming_or_running[0]
  }

  const body = [
    {
      type: 'header',
      value: {
        preTitle: indexPage.headerPreTitle,
        title: indexPage.headerTitle,
        text: indexPage.headerText,
        image: indexPage.headerImage,
        nearestTransmission: nearestTransmission
      }
    },
    {
      type: 'upcomming',
      value: {
        title: indexPage.upcommingTitle,
        text: indexPage.upcommingText,
        webinars: webinars.upcomming_or_running
      }
    },
    {
      type: 'suggestions',
      value: {
        title: indexPage.suggestionsTitle,
        form: indexPage.suggestionsForm,
        pageId: indexPageId
      }
    },
    {
      type: 'closed',
      value: {
        title: indexPage.pastTitle,
        text: indexPage.pastText,
        webinars: webinars.closed
      }
    }
  ]
  return {
    props: {
      head,
      navbar,
      body,
      footer
    }
  }
}

const Home = ({ head, navbar, body, footer }) => {
  return <View
    {...{ head, navbar, footer }}>
    {
      body.map((section, index) => {
        if (section.type === 'header') {
          return <Header
            key={index}
            id={section.type}
            order={index}
            {...section.value}
            recordedSectionID="closed" />
        }
        if (section.type === 'upcomming') {
          return <Upcomming
            key={index}
            id={section.type}
            order={index}
            {...section.value} />
        }
        if (section.type === 'suggestions') {
          return <Suggestions
            key={index}
            id={section.type}
            order={index}
            {...section.value} />
        }
        if (section.type === 'closed') {
          return <Recorded
            key={index}
            id={section.type}
            order={index}
            {...section.value} />
        }
        return null
      })
    }
    <Breadcrumb />
  </View>
}

Home.propTypes = {
  head: PropTypes.object,
  navbar: PropTypes.object,
  body: PropTypes.array,
  footer: PropTypes.object
}

export { getServerSideProps }
export default Home
